import React from "react";

const PrebridalPackageBook = () => {
  return (
    <div className="bridalMakeUpPackageBook">
      <h5>Book Your Appointment Today</h5>
      <p>
        Ready to experience the best Pre-Bridal Treatments in Bangalore and{" "}
        <a href="https://scentlifestyle.com/pre-bridal-treatments">Pre-Wedding Makeups in Bangalore</a>? Contact{" "}
        <a href="https://scentlifestyle.com/">SCENT</a> today to schedule your appointment. Our team is
        here to provide you with a comprehensive beauty regimen that ensures you
        look and feel your best on your wedding day.
      </p>
      <p>
        For more information or to book a consultation, visit our website or
        call us directly. Let SCENT help you make your wedding day truly
        unforgettable with our exceptional pre-bridal services.
      </p>
    </div>
  );
};

export default PrebridalPackageBook;
